import enUS from './en-US.json';
import esMX from './es-MX.json';
import esCO from './es-CO.json';
import ptBR from './pt-BR.json';
import frFR from './fr-FR.json';
import nlNl from './nl-NL.json';

const config = {
  'en-US': enUS,
  'es-MX': esMX,
  'es-CO': esCO,
  'pt-BR': ptBR,
  'fr-FR': frFR,
  'nl-NL': nlNl,
  'spanish': esMX,
  'english': enUS,
};

export const DEFAULT_LANG = 'es-MX';

export const supported = Object.keys(config);

export default config;
